/**
 * Feature flags (local / feature branch). Prod: all false until rollout.
 * Enable v2 hub: set REACT_APP_SERVICE_REQUEST_V2=1 in .env before npm start/build.
 */
export const features = {
  serviceRequestV2: process.env.REACT_APP_SERVICE_REQUEST_V2 === '1',
};
